import * as React from 'react';
import * as styles from './DueDateRemoveButton.scss';
import { ActionButton } from '@fluentui/react/lib/Button';
import { announceDueDateRemoved } from '../dueDates.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import type { IIconProps } from '@fluentui/react/lib/Icon';
import { observer } from 'mobx-react-lite';
import { removeDueDateText } from 'owa-locstrings/lib/strings/removeduedatetext.locstring.json';
import { setAnnouncement } from 'owa-timestream-store';
import loc from 'owa-localize';

const iconProps: IIconProps = {
    className: styles.removeDueDateIcon,
    iconName: ControlIcons.RemoveEvent,
};

export default observer(function DueDateRemoveButton({
    onRemoveDueDate,
}: {
    onRemoveDueDate: () => void;
}) {
    const onClick = React.useCallback(() => {
        setAnnouncement(loc(announceDueDateRemoved));
        onRemoveDueDate();
    }, [onRemoveDueDate]);

    return (
        <ActionButton
            className={styles.removeDueDate}
            iconProps={iconProps}
            text={loc(removeDueDateText)}
            onClick={onClick}
        />
    );
});
